import { useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { useLayout } from "../../context/LayoutContext";

// Sidebar width constants (must match MainComponent/SideBar).
const drawerWidth = 240;
const drawerWidthXXL = 300;
const drawerWidthUHD = 360;
const closedDrawerWidth = 72;
const closedDrawerWidthXXL = 125;
const closedDrawerWidthUHD = 150;

/**
 * Null-rendering bridge: the toast container (mounted above LayoutProvider)
 * can't read the sidebar state, so this component — mounted inside
 * MainComponent — writes the horizontal shift that keeps toasts centered
 * over the content area as a CSS custom property.
 */
export function ToastOffsetSync(): null {
  const theme = useTheme();
  const isUhd = useMediaQuery(theme.breakpoints.up("uhd"));
  const isXxl = useMediaQuery(theme.breakpoints.between("xxl", "uhd"));
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const { sidebarOpen: open } = useLayout();

  useEffect(() => {
    const width = isUhd
      ? open
        ? drawerWidthUHD
        : closedDrawerWidthUHD
      : isXxl
        ? open
          ? drawerWidthXXL
          : closedDrawerWidthXXL
        : isLgUp
          ? open
            ? drawerWidth
            : closedDrawerWidth
          : 0;

    document.documentElement.style.setProperty("--karda-toast-shift", `${width / 2}px`);
    return () => {
      document.documentElement.style.removeProperty("--karda-toast-shift");
    };
  }, [isUhd, isXxl, isLgUp, open]);

  return null;
}
